<h4 class="p-dialog-title">
  {{ tituloVentana }}
</h4>

<div class="contenido">
  {{ contenidoVentana }}
</div>

<div class="p-dialog-footer" class="buttons">
  <p-button
    [rounded]="true"
    class="main-button"
    variant="outlined"
    label="{{ modalconfirmacionViewModel.mensajes.botones.cancelar }}"
    icon="pi pi-times"
    (click)="cancelar()"
    (keydown.enter)="$event.preventDefault(); cancelar()"
    (keydown.space)="$event.preventDefault(); cancelar()"
  ></p-button>
  <p-button
    [rounded]="true"
    class="main-button"
    label="{{ modalconfirmacionViewModel.mensajes.botones.aceptar }}"
    icon="pi pi-check"
    (click)="aceptar()"
    (keydown.enter)="$event.preventDefault(); aceptar()"
    (keydown.space)="$event.preventDefault(); aceptar()"
  ></p-button>
</div>
